export type ActionTaken = string;
export const ActionTakenCreate: ActionTaken = '0';
export const ActionTakenUpdate: ActionTaken = '1';
export const ActionTakenDelete: ActionTaken = '2';
